import { Navigate, Route } from "react-router";
import { allRoutes } from "../../assets/routes/allRoutes";
import Login from "../containers/login";
import Registration from "../containers/registration";
import PageNotFound from "../containers/pageNotFound";
import ForgetPassword from "../containers/forgetPassword";
import ResetPassword from "../containers/resetPassword";
import PermissionRoute from "./PermissionRoute";
import Dashboard from "../containers/dashboard";
import VerifyOtp from "../containers/verifyOtp";
import CheckForPermittedModules from "../containers/sidebar/common/CheckForPermittedModules";
import Employees from "../containers/sidebar/employeesModals";
import Designations from "../containers/sidebar/designations";
import EmployeesMain from "../containers/sidebar/employeesModals/employeesMain";
import EmployeeNewMain from "../containers/sidebar/employeesNew/EmployeesNewMain";
import Departments from "../containers/sidebar/departments";
import Branches from "../containers/sidebar/branches";
import AccountSettings from "../containers/sidebar/accountSettings/AccountSettings";
import AuditTrail from "../containers/sidebar/auditTrails";
import RolesMain from "../containers/sidebar/roles";
import ForgotPassword from "../containers/sidebar/accountSettings/ForgotPassword";
import SecurityGroupMain from "../containers/sidebar/securityGroups";
import { element } from "prop-types";
import CustomMain from "../containers/sidebar/customAddons";
import ChangePassword from "../containers/sidebar/common/ChangePassword";
import MyProfile from "../containers/sidebar/myprofile/MyProfile";
import CustomAddonsPage from "../containers/sidebar/customAddons/MainPageNew";
import CustomAddonMain from "../containers/sidebar/customAddons";

console.log("executing routes page");

export const publicRoutes = [
  {
    path: allRoutes.login,
    element: <Login />,
    route: Route,
  },
  {
    path: allRoutes.register,
    element: <Registration />,
    route: Route,
  },
  {
    path: allRoutes.pageNotFound,
    element: <PageNotFound />,
    route: Route,
  },
  {
    path: allRoutes.forgetPassword,
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: allRoutes.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: allRoutes.verifyOtp,
    element: <VerifyOtp />,
    route: Route,
  },
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
  },
];

// export const permittedModulesRoute = {
//   path: allRoutes.permittedModules,
//   element: <CheckForPermittedModules />,
// };

export const authRoutes = [
  // awn
  {
    path: allRoutes.permittedModules,
    element: <CheckForPermittedModules />,
  },
  {
    path: allRoutes.changeNewPassword,
    element: <ChangePassword />,
  },
  {
    path: "*",
    element: <Navigate to={allRoutes.dashboard} />,
    route: Route,
  },
  {
    path: allRoutes.dashboard,
    element: (
      <PermissionRoute
        component={Dashboard}
        required_permission="Dashboard_read"
      />
    ),
    route: Route,
  },
  {
    path: allRoutes.designations,
    element: <Designations />,
    route: Route,
  },
  {
    path: allRoutes.departments,
    element: <Departments />,
    route: Route,
  },
  {
    path: allRoutes.empolyeesModal,
    element: <EmployeesMain />,
    route: Route,
  },
  {
    path: allRoutes.employeeProfile,
    element: <EmployeeNewMain />,
    route: Route,
  },
  {
    path: allRoutes.securityGroups,
    element: <SecurityGroupMain />,
    route: Route,
  },
  {
    path: allRoutes.branches,
    element: <Branches />,
    route: Route,
  },
  {
    path: allRoutes.accountSettings,
    element: <AccountSettings />,
  },
  {
    path: allRoutes.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: allRoutes.auditTrail,
    element: <AuditTrail />,
    route: Route,
  },

  {
    path: allRoutes.roles,
    element: <RolesMain />,
    route: Route,
  },
  {
    path: allRoutes.employees,
    element: <Employees />,
    route: Route,
  },

  {
    path: allRoutes.customAddon,
    element: <CustomAddonMain />,
    route: Route,
  },
  {
    path: allRoutes.myProfile,
    element: <MyProfile />,
    route: Route,
  },
];
